import React from 'react';

export const Contact = ({ data }) => {
  if (!data) return null;

  return (
    <>
      <section id="contact">
        <div className="container">
          <div className="section-title">
            <span className="section-label">Contact</span>
            <h2>Let&apos;s Build Something</h2>
            <p>
              Have a product idea? Want a demo? We&apos;d love to hear from you.
            </p>
          </div>

          <div className="text-center">
            <a
              href={`mailto:${data.email}`}
              className="contact-email-link"
            >
              {data.email}
            </a>

            <div className="contact-info-row">
              <div className="contact-info-item">
                <i className="fa fa-map-marker"></i>
                <span>{data.address}</span>
              </div>
              <div className="contact-info-item">
                <i className="fa fa-phone"></i>
                <span>{data.phone}</span>
              </div>
            </div>

            <div className="social-links">
              {data.facebook && (
                <a
                  href={data.facebook}
                  className="social-link"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Facebook"
                >
                  <i className="fa fa-facebook"></i>
                </a>
              )}
            </div>
          </div>
        </div>
      </section>

      <footer id="footer">
        <div className="container">
          <p>
            &copy; 2026 Mindware. All rights reserved.{' '}
            &middot;{' '}
            <a href="/privacy_policy_alora">Privacy Policy</a>
          </p>
        </div>
      </footer>
    </>
  );
};
